(function () {
  'use strict';
  function track(name, fields) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name, quiz_version: 2 }, fields || {})); } catch (ignore) {}
    try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, Object.assign({ quiz_version: 2 }, fields || {})); } catch (ignore) {}
  }
  function init(root) {
    if (root.dataset.quizReady || !window.MomoQuizRecommendations) return;
    root.dataset.quizReady = 'true';
    var engine = window.MomoQuizRecommendations;
    var catalog;
    try { catalog = JSON.parse(root.querySelector('[data-quiz-catalog]').textContent); } catch (error) { return; }
    var form = root.querySelector('[data-quiz-form]');
    var questions = Array.from(form.querySelectorAll('[data-quiz-question]'));
    var resultArea = root.querySelector('[data-quiz-result]');
    var index = 0, answers = {}, result = null, started = false, emailPending = false;
    var gate = root.querySelector('[data-quiz-gate]');
    var resultId = root.querySelector('h1').id + '-result';
    form.hidden = false;
    function focusQuestion() { questions[index].querySelector('legend').focus({ preventScroll: true }); }
    function showQuestion(nextIndex, focus) {
      index = nextIndex;
      questions.forEach(function (question, i) { question.hidden = i !== index; });
      form.hidden = false;
      root.querySelector('.mqp-header').hidden = false;
      resultArea.hidden = true;
      if (gate) gate.hidden = true;
      root.querySelector('[data-quiz-progress-wrap]').hidden = false;
      root.querySelector('[data-quiz-progress]').value = index + 1;
      root.querySelector('[data-quiz-progress-text]').textContent = 'question ' + (index + 1) + ' of ' + questions.length;
      root.querySelector('[data-quiz-back]').hidden = index === 0;
      root.querySelector('[data-quiz-error]').textContent = '';
      root.querySelector('[data-quiz-next]').firstChild.textContent = index === questions.length - 1 ? 'see my result ' : 'continue ';
      if (focus) focusQuestion();
    }
    function create(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    }
    function paragraph(parent, text, className) { parent.appendChild(create('p', className || '', text)); }
    function buttonLink(parent, text, url, mode) {
      var link = create('a', 'mqp-button', text);
      link.href = url;
      link.dataset.quizChoice = mode;
      link.appendChild(create('span', '', '→'));
      link.lastChild.setAttribute('aria-hidden', 'true');
      parent.appendChild(link);
    }
    function cardShell(image, alt, app) {
      var card = create('article', 'mqp-card' + (app ? ' mqp-card--app' : ''));
      if (image) {
        var art = create('div', 'mqp-card-art');
        var img = create('img');
        img.src = image; img.alt = alt; img.width = 800; img.height = 800; img.loading = 'eager';
        art.appendChild(img); card.appendChild(art);
      }
      var body = create('div', 'mqp-card-body'); card.appendChild(body);
      return { card: card, body: body };
    }
    function pdfCard(product, goalFit) {
      var native = catalog.products[product.handle] || {};
      var built = cardShell(native.image, product.name + ' pdf cover', false), body = built.body;
      paragraph(body, goalFit.fits ? '[ your goal + current setup ]' : '[ your goal · check the fit ]', 'mqp-eyebrow');
      body.appendChild(create('h4', '', product.name));
      paragraph(body, product.detail);
      var facts = create('dl', 'mqp-card-facts');
      [['schedule', product.schedule], ['equipment', product.equipment]].forEach(function (fact) {
        var row = create('div'); row.appendChild(create('dt', '', fact[0])); row.appendChild(create('dd', '', fact[1])); facts.appendChild(row);
      });
      body.appendChild(facts);
      paragraph(body, product.requirement);
      if (goalFit.notes.length) {
        var fit = create('div', 'mqp-fit-notes');
        paragraph(fit, 'before you choose it', 'mqp-fit-label');
        goalFit.notes.forEach(function (note) { paragraph(fit, note); });
        body.appendChild(fit);
      }
      if (native.price) paragraph(body, native.price, 'mqp-price');
      var url = native.url && native.url.charAt(0) === '/' ? native.url : '/products/' + product.handle;
      buttonLink(body, 'see the ' + product.name.replace(/^the /, '') + ' pdf', url, goalFit.fits ? 'pdf' : 'pdf_goal_option');
      paragraph(body, 'the plan + the food guide, in one pdf. no app needed.', 'mqp-small');
      return built.card;
    }
    function guideCard() {
      var guide = result.guide, native = catalog.products[guide.handle] || {};
      var article = create('article', 'mqp-guide');
      article.dataset.quizGuide = 'perfect-form';
      if (native.image) { var image = create('img'); image.src = native.image; image.alt = 'perfect form pdf cover'; image.width = 180; image.height = 220; image.loading = 'lazy'; article.appendChild(image); }
      var body = create('div');
      paragraph(body, '[ optional guide ]', 'mqp-eyebrow');
      body.appendChild(create('h4', '', guide.name));
      paragraph(body, guide.detail);
      paragraph(body, guide.note, 'mqp-small');
      if (native.price) paragraph(body, native.price, 'mqp-guide-price');
      buttonLink(body, 'explore perfect form', '/products/perfect-form', 'pdf_guide');
      article.appendChild(body); return article;
    }
    function pdfLane() {
      var lane = create('section', 'mqp-format-lane'); lane.dataset.quizFormatLane = 'pdf'; lane.id = resultId + '-pdf';
      lane.setAttribute('aria-label', 'pdf programs and optional guide');
      paragraph(lane, '[ one pdf ]', 'mqp-eyebrow');
      lane.appendChild(create('h3', 'mqp-lane-title', 'keep the pdf.'));
      lane.appendChild(pdfCard(result.goalPdf.product, result.goalPdf));
      if (result.pdf.product && result.pdf.product.key === 'home') {
        var alternative = create('div', 'mqp-current-setup');
        paragraph(alternative, 'for your current setup', 'mqp-fit-label');
        paragraph(alternative, 'stronger at home: four days a week, household supports + resistance. a foundation plan for your current setup.');
        var link = create('a', '', 'see stronger at home →'); link.href = '/products/stronger-at-home'; link.dataset.quizChoice = 'pdf_home_alternative'; alternative.appendChild(link); lane.appendChild(alternative);
      }
      lane.appendChild(guideCard()); return lane;
    }
    function appLane() {
      var lane = create('section', 'mqp-format-lane'); lane.dataset.quizFormatLane = 'app'; lane.id = resultId + '-app';
      lane.setAttribute('aria-label', 'app membership');
      paragraph(lane, '[ the app ]', 'mqp-eyebrow');
      lane.appendChild(create('h3', 'mqp-lane-title', 'train in the app.'));
      lane.appendChild(appCard(result.app, true)); return lane;
    }
    function appCard(app, alternative) {
      var built = cardShell(catalog.appImage, 'momo app home with training programs', true), body = built.body;
      paragraph(body, '[ ' + app.label + ' ]', 'mqp-eyebrow');
      body.appendChild(create('h4', '', alternative ? app.name : 'train in the app.'));
      if (alternative) paragraph(body, app.detail);
      paragraph(body, app.note);
      // oct 29 2026, the brand pass: the one door, in her words [the home + every pdp app block say the same]. no price talk, no e-com words.
      paragraph(body, 'every exercise filmed with how to do it right next to it: the mechanics first, then slow it down to activate.');
      paragraph(body, 'get it all on the momo[muscle] app. 7 days free.', 'mqp-door');
      paragraph(body, '28,000+ have joined the momo[muscle] app.', 'mqp-proof');
      buttonLink(body, 'start free for 7 days', catalog.appUrl, 'app');
      paragraph(body, '7 days free for eligible new members. renewal + cancellation terms at checkout.', 'mqp-small');
      return built.card;
    }
    function payload() {
      var fields = {
        quiz_version: 2,
        recommendation: result.key,
        recommendation_kind: result.kind,
        program_handle: result.pdf.product ? result.pdf.product.handle : '',
        goal_program_handle: result.goalPdf.product.handle,
        goal_program_fits_answers: result.goalPdf.fits,
        preferred_format: answers.format,
        training_experience: answers.experience,
        equipment: answers.equipment,
        training_frequency: answers.days + 'x',
        goals: [answers.goal]
      };
      // Legacy program automations are only eligible for a matched legacy PDF.
      if (result.bodyType) fields.body_type = result.bodyType;
      return fields;
    }
    function showResult() {
      result = engine.recommend(answers);
      if (!result) return;
      form.hidden = true;
      root.querySelector('.mqp-header').hidden = true;
      root.querySelector('[data-quiz-progress-wrap]').hidden = true;
      try { localStorage.setItem('mm_quiz_answers', JSON.stringify(payload())); } catch (ignore) {}
      track('quiz_finished', { archetype: result.bodyType || result.key, recommendation: result.key, preferred_format: answers.format });
      if (!gate || gateDone()) revealResult(); else showGate();
    }
    function gateDone() { try { return localStorage.getItem('mm_quiz_email_done') === '1'; } catch (ignore) { return false; } }
    function showGate() {
      // oct 28 2026, her word "quiz gate": the result opens on the email again. the optional box [closed oct 16, open oct 19 + 27] brought 0 emails from 47 finishers; the old gate ran at 46 percent.
      resultArea.hidden = true;
      gate.hidden = false;
      track('quiz_gate_viewed', { archetype: result.bodyType || result.key, optional: false });
      var gateTitle = gate.querySelector('[data-quiz-gate-title]');
      if (gateTitle) gateTitle.focus({ preventScroll: true });
      gate.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    function revealResult() {
      if (gate) gate.hidden = true;
      resultArea.hidden = false;
      root.querySelector('[data-quiz-result-label]').textContent = '[ your starting point ]';
      root.querySelector('[data-quiz-result-title]').textContent = result.title;
      root.querySelector('[data-quiz-result-intro]').textContent = result.intro;
      var cards = root.querySelector('[data-quiz-result-cards]'); cards.replaceChildren();
      cards.classList.add('mqp-result-cards--formats');
      if (answers.format === 'compare') {
        var jumpLinks = create('nav', 'mqp-format-jumps'); jumpLinks.setAttribute('aria-label', 'compare formats');
        [['pdf', 'pdf + optional guide ↓'], ['app', 'app membership ↓']].forEach(function (item) { var link = create('a', '', item[1]); link.href = '#' + resultId + '-' + item[0]; jumpLinks.appendChild(link); });
        cards.appendChild(jumpLinks);
      }
      if (answers.format !== 'app') cards.appendChild(pdfLane());
      if (answers.format !== 'pdf') cards.appendChild(appLane());
      var summary = root.querySelector('[data-quiz-answers]'); summary.replaceChildren();
      var names = { goal: 'goal', experience: 'starting point', equipment: 'equipment', days: 'available days', format: 'format' };
      Object.keys(names).forEach(function (key) { summary.appendChild(create('dt', '', names[key])); summary.appendChild(create('dd', '', engine.labels[key][answers[key]])); });
      track('quiz_result_viewed', { archetype: result.bodyType || result.key, recommendation: result.key });
      root.querySelector('[data-quiz-result-title]').focus({ preventScroll: true });
      resultArea.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    form.addEventListener('change', function (event) {
      if (event.target.type !== 'radio') return;
      if (!started) { started = true; track('quiz_started'); }
      answers[event.target.name] = event.target.value;
      root.querySelector('[data-quiz-error]').textContent = '';
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var key = questions[index].dataset.quizQuestion;
      if (!answers[key]) {
        root.querySelector('[data-quiz-error]').textContent = 'choose one answer to continue.';
        questions[index].querySelector('input').focus(); return;
      }
      track('quiz_step_completed', { step: index + 1, question: key, value: answers[key] });
      if (index === questions.length - 1) showResult(); else showQuestion(index + 1, true);
    });
    root.querySelector('[data-quiz-back]').addEventListener('click', function () { track('quiz_step_back', { from: index + 1 }); showQuestion(index - 1, true); });
    root.querySelector('[data-quiz-edit]').addEventListener('click', function () { showQuestion(0, true); form.scrollIntoView({ block: 'start', behavior: 'auto' }); });
    root.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      form.reset(); answers = {}; result = null; started = false;
      if (gate) gate.hidden = true;
      try { localStorage.removeItem('mm_quiz_answers'); } catch (ignore) {}
      track('quiz_restarted'); showQuestion(0, true); form.scrollIntoView({ block: 'start', behavior: 'auto' });
    });
    resultArea.addEventListener('click', function (event) {
      var link = event.target.closest('[data-quiz-choice]');
      if (link) track('quiz_recommendation_clicked', { recommendation: result.key, format: link.dataset.quizChoice });
    });
    var gateEdit = root.querySelector('[data-quiz-gate-edit]');
    if (gateEdit) gateEdit.addEventListener('click', function () { track('quiz_gate_edit'); showQuestion(0, true); form.scrollIntoView({ block: 'start', behavior: 'auto' }); });
    var emailForm = root.querySelector('[data-quiz-email-form]');
    emailForm.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (emailPending || !result || !emailForm.reportValidity()) return;
      var input = emailForm.querySelector('input'), email = input.value.trim();
      if (!email) return;
      emailPending = true;
      var button = emailForm.querySelector('button'); button.disabled = true;
      var status = root.querySelector('[data-quiz-email-status]'); status.textContent = 'adding you to the list…';
      var fields = payload(), submittedType = result.bodyType, submittedKey = result.key;
      track('quiz_email_submit', { archetype: result.bodyType || result.key, via: 'gate' });
      var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 10000);
      var options = function (body) { return { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body), signal: controller.signal }; };
      try {
        var subscription = { data: { type: 'subscription', attributes: { custom_source: 'Program Finder v2 Gate', profile: { data: { type: 'profile', attributes: { email: email, properties: fields } } } }, relationships: { list: { data: { type: 'list', id: 'Uqywym' } } } } };
        var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Tdz4Yw', options(subscription));
        if (!response.ok) throw new Error('subscription_rejected');
        clearTimeout(timeout);
        status.textContent = 'signup received. opening your result.';
        try { localStorage.setItem('mm_quiz_email_done', '1'); } catch (ignore) {}
        track('quiz_gate_api_capture', { archetype: submittedType || submittedKey });
        revealResult();
        // Avoid sending setup/home/no-match visitors into the old Fighter-default result flow.
        var metric = submittedType ? 'Quiz Completed' : 'Program Finder Completed';
        var eventBody = { data: { type: 'event', attributes: { properties: fields, metric: { data: { type: 'metric', attributes: { name: metric } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } } };
        fetch('https://a.klaviyo.com/client/events/?company_id=Tdz4Yw', { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(eventBody), keepalive: true }).catch(function () {});
      } catch (error) {
        status.textContent = 'signup did not go through. try again.';
        track('quiz_gate_api_capture_failed', { archetype: submittedType || submittedKey });
      } finally { clearTimeout(timeout); emailPending = false; button.disabled = false; }
    });
    showQuestion(0, false);
  }
  function initAll(scope) { scope.querySelectorAll('[data-momo-quiz]').forEach(init); }
  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
